// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var React = require("react");
var Client = require("../../clients/types/Client.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Text__Jsx3 = require("../../../uikit/reason/helpers/Text__Jsx3.bs.js");
var View__Jsx3 = require("../../../uikit/reason/helpers/View__Jsx3.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ReactRender = require("../../utils/ReactRender.bs.js");
var Types__User = require("../../user/Types__User.bs.js");
var NonEmptyList = require("../../common/types/NonEmptyList.bs.js");
var Conversations__Types = require("../types/Conversations__Types.bs.js");
var WarningSection__Jsx3 = require("../../../uikit/reason/atoms/Sections/WarningSection__Jsx3.bs.js");

function ConversationNotAnonymousWarning$ConditionalWarning(props) {
  var conversation = props.conversation;
  var match = Belt_Option.map(conversation.context, Conversations__Types.Context.getMatches);
  var anonymousSellerMatches = match !== undefined && typeof match === "object" && match.NAME === "SELLER_MATCHES" ? NonEmptyList.fromArray(Belt_Array.keep(match.VAL, (function (match_) {
                return match_.property.anonymousMatching;
              }))) : undefined;
  var contextOwner = Belt_Option.map(conversation.context, Conversations__Types.Context.getOwner);
  var match$1 = conversation.id;
  var isNew;
  isNew = match$1.TAG === /* Existing */0 ? false : true;
  return ReactRender.fromOption(anonymousSellerMatches, (function (matches) {
                var length = List.length(NonEmptyList.tail(matches)) + 1 | 0;
                return React.createElement(View__Jsx3.make, {
                            mt: {
                              NAME: "px",
                              VAL: 10
                            },
                            justifyContent: "flexEnd",
                            children: Caml_option.some(React.createElement(WarningSection__Jsx3.make, {
                                      children: null
                                    }, isNew ? React.createElement(View__Jsx3.make, {
                                            mb: "xs",
                                            children: Caml_option.some(React.createElement(Text__Jsx3.make, {
                                                      fontWeight: "bold",
                                                      children: "This conversation will not be anonymous"
                                                    }))
                                          }) : null, "Your name remains hidden on " + ((
                                        length > 1 ? String(length) + " of your matching sellers" : "your seller \"" + (Belt_Option.getWithDefault(Client.label(NonEmptyList.head(matches).property.client), "name unavailable") + "\"")
                                      ) + (". However, " + (Belt_Option.getWithDefault(Belt_Option.map(Belt_Option.flatMap(contextOwner, Types__User.anonymousUserToOption), (function (user) {
                                                      return Types__User.label(user) + " will see your name";
                                                    })), "your name will be visible") + " in this conversation")))))
                          });
              }));
}

var ConditionalWarning = {
  make: ConversationNotAnonymousWarning$ConditionalWarning
};

var Chat;

var View;

var $$Text;

var Form;

var Buttons;

exports.Chat = Chat;
exports.View = View;
exports.$$Text = $$Text;
exports.Form = Form;
exports.Buttons = Buttons;
exports.ConditionalWarning = ConditionalWarning;
/* react Not a pure module */
